import { Box, Grid, Stack, useMediaQuery } from "@mui/material";
import React from "react";
import Progressor from "../../components/pages/register/Progressor";
import { useTheme } from "@emotion/react";
import Form from "../../components/pages/register/contact-info/Form";
const ContactInfo = () => {
    const theme = useTheme();
    const isMdScreen = useMediaQuery(theme.breakpoints.down("md"));
    return (
        <Box className="page">
            <Grid container justifyContent={"center"}>
                <Grid
                    container
                    item
                    direction={"row"}
                    rowSpacing={5}
                    columnSpacing={isMdScreen ? 0 : 10}
                    md={9}
                    sm={12}
                    xs={12}
                >
                    <Grid item xs={12}>
                        <Form />
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
};

export default ContactInfo;
